export default "skymp5-front/a47a981c818fb9c111795d7a3843e6b1.gif";